/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2017, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'jquery',
	'underscore',
	'text!../templates/FilterGroupsTemplate.html',
	'../common/NextView',
	'doT'
], function ($, _, FilterGroups, NextView, dot){

	var FilterGroupsDialog = NextView.extend({

		events: {
			'primaryaction .filterGroupColumn': '_selectItem'
		},

		controller: null,
		numberOfGroups: null,

		init:function(options){
			FilterGroupsDialog.inherited('init', this, arguments);
			this.controller = options.controller;
			this._idList = options.idList;
		},

		render:function() {
			var groupArray = [];
			var groups = this.controller.getGroups(this._idList);
			for(var i = 0; i < groups.length; i++){
				groupArray.push({ text: groups[i].split(':')[1], groupId: groups[i] });
			}
			if (!groupArray.length) {
				// callbackClose is bound to AuthoringToolbar.closeFlyout function when instantiating SubView of this dialog
				if (this.callbackClose) {
					this.callbackClose();
				}
			} else {
				this.dotTemplate = dot.template(FilterGroups);
				var sHtml = this.dotTemplate({ array:groupArray });
				this.$el.html(sHtml);
				this._setFocus();
			}
		},

		_setFocus:function(){
			this.$el.find('.filterGroupColumn:first').focus();
		},

		_getSelectedNodeIds: function(selectedNodes){

			var nodeIds = [];
			for(var i = 0; i < selectedNodes.length; i++){
				nodeIds.push(selectedNodes[i].id);
			}

			return nodeIds;

		},

		_selectItem: function(evt) {
			var groupId = $(evt.currentTarget).attr('data');
			this.controller.eventGroups.addToGroup(groupId, this._idList, _.uniqueId('_addToGroup_'));
			this.render();
		}

	});

	return FilterGroupsDialog;

});
